import { render, staticRenderFns } from "./AcceptInvitation.vue?vue&type=template&id=48d46e0f&scoped=true&"
import script from "./AcceptInvitation.vue?vue&type=script&lang=js&"
export * from "./AcceptInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AcceptInvitation.vue?vue&type=style&index=0&id=48d46e0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d46e0f",
  null
  
)

export default component.exports